import { createQueryKeys } from '@lukemorales/query-key-factory'
import { sdk } from '@services/sdk'

export const stories = createQueryKeys('stories', {
  all: () => ({
    queryKey: [true],
    queryFn: async ({ meta, signal }) => sdk.stories({}, meta?.headers, signal),
  }),
  detail: (storyId: number) => ({
    queryKey: [storyId],
    queryFn: async ({ meta, signal }) =>
      sdk.story({ storyId }, meta?.headers, signal),
  }),
})
